import { Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import Select from 'react-select';
import { v4 as uuidv4 } from "uuid";


const MoleculeSingleSelectBoxWithCreatable = ({ label, tooltip, placeholder, options, value, onChange, disable = false }) => {
    const uniqueId = uuidv4();

    const handleChange = (selectedOption) => {
        onChange(selectedOption);
    };

    return (
        <Col className="text-start">
            <Form.Group controlId={`multiSelectbox-${uniqueId}`} className="d-flex align-items-start align-items-center">
                {/* Icon Info với Tooltip */}
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{tooltip}</Tooltip>}
                >
                    <InfoCircle className="me-1 mb-1 text-primary" style={{ cursor: "pointer", fontSize: "16px", minWidth: "16px" }} />
                </OverlayTrigger>
                <span className="text-nowrap me-2">{label}</span>
                <Select
                    isSearchable
                    className="w-100"
                    placeholder={placeholder}
                    options={options}
                    value={value}
                    onChange={handleChange}
                    classNamePrefix="singleSelect"
                    disabled={disable}
                />
            </Form.Group>
        </Col>
    );
};

export default MoleculeSingleSelectBoxWithCreatable
